import React from 'react';
import PasswordGenerator from './components/PasswordGenerator/PasswordGenerator.tsx';

function App() {
  return (
    <div className="App">
      <PasswordGenerator />
    </div>
  );
}

export default App;

